import { Grid } from "@mui/material";
import { FormAutoCompleteSelectDynamic } from "../../../query-builder/hooks-form-querybuilder/form-autocomplete-select.dynamic.component";
import { contactApiKeyStore } from "../../../../api/contact-api-key-store";
import FormFormattedInput from "../../../../components/hook-form/form-formatted-input.component";
import { PHONENUMBER_FORMAT } from "../../../../constants";
import { useFormContext } from "react-hook-form";
import { useState } from "react";

export const AdHocFormComponent = () => {

    const { setValue } = useFormContext();
    const [disableCellPhone, setDisableCellPhone] = useState<boolean>(false);

    const handleNameChange = (contactData: any) => {
        setDisableCellPhone(!!contactData)
        setValue('cellPhone', contactData?.cellPhone ?? '');
    }

    const handleInputChange = (value: any) => {
        setValue('name', { name: value ?? '', adHocContactID: 0 })
    }

    return (
        <Grid container spacing={2}>
            <Grid item lg={4} sm={4} xl={4} xs={4}>
                <FormAutoCompleteSelectDynamic
                    name="name"
                    label="Name"
                    freeSolo
                    onInputChange={handleInputChange}
                    onChange={handleNameChange}
                    getQueryKeyConfig={() => contactApiKeyStore.getContactHOC()}
                    optionsValueKey="adHocContactID"
                    optionsLabelKey="name"
                    optionOtherLabelKey="cellPhone"
                />
            </Grid>
            <Grid item lg={4} sm={4} xl={4} xs={4}>
                <FormFormattedInput
                    name="cellPhone"
                    label="Cell Phone"
                    disabled={disableCellPhone}
                    format={PHONENUMBER_FORMAT} />
            </Grid>
        </Grid>
    );
}